export const createMessageOrigin = (origin: string): string => {
  const app = 'TecEx'; // TODO use dynamic source when multiple portals are created
  return `${app} - Message sent from ${origin}`;
};
